import { AxiosRequestConfig } from 'axios';
import { apiClient } from '@/api/client/ApiClient';

export async function makeDataQuery<T>(params: AxiosRequestConfig<T>) {
  const param = await apiClient(params);
  return param.data;
}
